import {useEffect} from 'react';
import Footer from '../components/Footer';
import MainLogin from '../components/MainLogin';
import NavBarLogin from '../components/NavBarLogin';
import ModalCodigo from '../components/ModalCodigo';
import ModalRecuperar from '../components/ModalRecuperar';
import '../css/login.css';
import { Tutorial } from '../components/Tutorial';
 
function Login(){
    
    useEffect(() => {
        localStorage.removeItem(process.env.REACT_APP_CODIGO_APROBADO)
        localStorage.setItem(process.env.REACT_APP_BIENVENIDA, 1)
    },[]) 
    return(
        <> 
            <NavBarLogin/>
            <MainLogin/>
            <Footer isVisibleMobile={true}/>
            <ModalCodigo/>
            <ModalRecuperar/>
            <Tutorial finalId={1}/>
        </>
    );
}


export default Login;